import sizes from '../../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../../utills/pxToRem'
import colors from '../../../../../theme/foundations/colors'
import {fonts} from '../../../../../theme/foundations/fonts'

export const wishlistRemoveButton = {
    _hover: {textDecoration: 'underline'},
    color: colors.cav_calltoaction_darkred,
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    fontWeight: '500',
    fontSize: {base: pxToRem(10), md: pxToRem(12)},
    fontStyle: 'normal',
    fontFamily: fonts.primary,
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textTransform: 'uppercase',
    outline: 'none',
    borderBottom: '2px solid transparent',
    transition: 'border-bottom 0.2s ease-in-out',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(10),
        padding: pxToRem(4),
        borderBottom: 'none',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        whiteSpace: 'normal',
        marginBottom: pxToRem(6),
        alignSelf: 'flex-start'
    }
}
